export const ENABLE_MESSAGING_THREADS_V2 = 'enable_messaging_threads_v2';

export const DISABLE_MESSAGING_QUESTIONNAIRE =
  'disable_messaging_questionnaire';
